import {tail} from 'lodash';

export default function TripListService(
    userService,
    tripAPI
) {
    'ngInject';

            const singleArrow = '<i class="i-cm-rarr"></i>';
            const doubleArrow = '<i class="i-cm-twin"></i>';

            const getLocations = (acc, location) => {
                // Disallow consecutive duplicates
                if (tail(acc) !== location) {
                    acc.push(location);
                }
                return acc;
            };

            const parseItinerary = ({TripItemType, ItineraryText}) => {
                if (!ItineraryText) {
                    return '';
                }

                switch (TripItemType) {
                    case 'Flight':
                    case 'Rail':
                    case 'EuRail':
                    case 'Eurostar':
                        const locations = ItineraryText
                            .split('|') // Text is pipe separated locations
                            .reduce(getLocations, []);

                        // Roundtrip
                        if (locations.length === 3 && locations[0] === locations[2]) {
                            return `${locations[0]}${doubleArrow}${locations[1]}`;
                        }

                        return locations.join(singleArrow);
                    case 'Car':
                        return ItineraryText && ItineraryText.replace(/\s->\s/g, singleArrow);
                    default:
                        return ItineraryText;
                }
            };
            const processTripProduct = (tripProduct) => ({
                ...tripProduct,
                Itinerary: parseItinerary(tripProduct),
            });
            const processTrip = (trip) => ({
                ...trip,
                TripProducts: trip.TripProducts.map(processTripProduct),
            });

            const processTrips = (trips) => trips.map(processTrip);

            return {
                getList: function(filters, offset, limit, orderBy, direction) {
                    const regionalSettings = userService.getRegionalSettings();

                    const request = angular.copy(filters);
                    const dateFrom = moment(request.DateFrom, regionalSettings.dateFormat);
                    const dateTo = moment(request.DateTo, regionalSettings.dateFormat);

                    request.Status = request.Status.value || undefined;
                    request.DateFrom = dateFrom.isValid() ? dateFrom.toISOString() : undefined;
                    request.DateTo = dateTo.isValid() ? dateTo.toISOString() : undefined;

                    request.OrderBy = (orderBy + direction) || 'TravelDate';
                    request.Offset = offset || 1;
                    request.Limit = limit || 20;

                    return tripAPI
                        .fetchTripsList(request)
                        .then(({data}) => processTrips(data));
                },
            };
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/list/trip-list-service.js